import React, { Component } from 'react';
import firebase from 'firebase/compat/app';
import {Form} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import 'bootstrap/dist/css/bootstrap.min.css';
import {emailValidation} from "./utils/validation";
import CheckBox from "./Components/CheckBox";

class LoginView extends Component {

    constructor() {
        super();
        this.state = {
            activeSubmit:false,
            validatedEmail:false,
            termChecked: false,
            email:'',
            emailSended: false,
        }
    }

    componentDidMount() {
    }

    handleChangeCheckbox = (label, id, isChecked) => {
      this.setState({termChecked: isChecked, activeSubmit: (isChecked && this.state.validatedEmail)});
    };

    handleChangeEmail = (e) => {
        let validate = emailValidation(e.target.value);
        this.setState({validatedEmail: validate, activeSubmit: (validate && this.state.termChecked), email:e.target.value});
    }

    submitPressed = () => {
        if(this.props.accessEmailType === 0) {
            this.props.onValidated();
        } else {
            let query = window.location.search.substring(1);
            const params = new URLSearchParams(query);
            let folderId = params.get('9RARLolCpX');
            let urlToFolder = 'https://event-movies.web.app/?9RARLolCpX=' + folderId;

            let url = 'https://us-central1-code-for-golf-shot-camera.cloudfunctions.net/sendMailFromDevice?dest=' + this.state.email + '*' + '<p></p>' + urlToFolder;

            let self = this;
            fetch(url)
                .then((result) => {
                    console.log(result);
                    self.setState({emailSended: true});
                }).catch((error) => {
                console.log(error);
            });

            self.setState({emailSended: true});
        }
    }

    back = () => {
        this.setState({activeSubmit:false,
            validatedEmail:false,
            termChecked: false,
            email:'',
            emailSended: false,});
    }

    render() {
        return (
            <div className="LoginViewRoot">

                <div className="LoginViewBody">

                {this.state.emailSended &&
                <div className="LoginViewBody2">
                    <Form.Label style={{fontSize: 14}} className="text-center">Thank you! Your Shot Tracer video download link will be automatically sent to your email shortly.
                        Make sure to check your Spam folder if you haven’t received your video within a couple of minuets.</Form.Label>
                    <div className="LoginViewBody">
                    <Button onClick={this.back} variant="primary" type="submit" active>
                        {'Resend email'}
                    </Button>
                    </div>
                </div>}

                {!this.state.emailSended && <Form noValidate validated={this.state.validatedEmail}>

                    <div className="LoginViewBody">
                        <Form.Label style={{fontSize: 20,}} className="font-weight-bold">Enter email address</Form.Label>
                    </div>

                    <div className="LoginViewBody">
                        {this.props.accessEmailType === 0 && <Form.Label style={{fontSize: 14}} className="text-center">Please enter your email bellow.</Form.Label>}
                    </div>

                    <div className="LoginViewBody">
                        {this.props.accessEmailType === 1 && <Form.Label style={{fontSize: 14}} className="text-center">You will receive your Shot Tracer video download link to your email. Please enter your email bellow.</Form.Label>}
                    </div>

                    <div style={{height:25}}></div>

                    <Form.Group  controlId="formBasicEmail">
                        <Form.Control type="email" placeholder="Enter email" onChange={this.handleChangeEmail}/>
                    </Form.Group>

                    <div style={{height:15}}></div>

                    <Form.Group controlId="formBasicCheckbox">
                        <CheckBox
                            label={<a>I have read and accept <a href="https://www.shottracerapp.com/">Terms & Conditions</a></a>}
                            handleCheckboxChange={this.handleChangeCheckbox}
                            id={'Switch on/off'}
                        />
                    </Form.Group>

                    <div style={{height:15}}></div>

                    <div className="LoginViewBody">

                    {this.state.activeSubmit && <Button onClick={this.submitPressed} variant="primary" type="submit" active>
                        {this.props.accessEmailType === 0 ? 'Open gallery' : 'Send gallery link to email'}
                    </Button>}
                    {!this.state.activeSubmit && <Button variant="primary" type="submit" disabled>
                        {this.props.accessEmailType === 0 ? 'Open gallery' : 'Send gallery link to email'}
                    </Button>}
                    </div>
                    <div className="LoginViewBody">
                        <div style={{height:1500}}></div>
                    </div>
                </Form>}
                </div>
            </div>
        );
    }
}

export default LoginView;
